export class IsVaultDeletableResponse {
    'deletable';
    'reasons';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "deletable",
            "baseName": "deletable",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "reasons",
            "baseName": "reasons",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IsVaultDeletableResponse.attributeTypeMap;
    }
    constructor() {
    }
}
